import shortend from './shortend'

export default {
  name: 'UrlShortened',
  path: 'url',
  meta: {
    label: 'url',
    auth: 'url'
  },
  component: {
    name: 'UrlShortened',
    render(c) {
      return c('router-view')
    }
  },
  children: [shortend]
}
